import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { SectionHeader_2, Card_6 } from '../../../../../component/landingComponent';
const PlPricing = () => {
    return (
        <div className='row mt-10  pb-5'>
            <div className="col-md-12 text-center mb-6">
                <SectionHeader_2
                    title= {`Pricing`}
                />
            </div>
            <div className="cta-area-wrapper px-20  pt-0 bg-none">
                <div className="section-heading">
                    <div className="text-wrapper">
                        <p className="text has_fade_anim mt-3 fs-1  text-grad-3" >Pricing Plans — Coming Soon</p>
                    </div>
                    <p className="text-gray-700 fs-3 mt-10">
                        We're crafting flexible and transparent pricing for you.
                        Stay tuned — powerful features, simple plans, and no surprises are just around the corner.
                    </p>
                </div>
            </div>
        </div>
    )
}

export {PlPricing}